<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Lista de Upsell'" :showBtn="false" :btnName="''" :btnRoute="''"
                   :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingList"/>

            <!-- Filters -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div v-if="!loadingList" class="
                  col-xs-12 col-sm-12 col-md-12
                  default-box
                  filters
                  complete-filter
                ">
                <div class="col-xs-12 col-sm-6 col-md-3 offset-top-20">
                  <div class="input-group input-with-date">
                    <label>Data Inicial</label>
                    <datepicker ref="programaticOpen3" v-model="filters.initialDate" :language="ptBR"
                                :format="customFormatter"/>
                    <i v-on:click="openCalendar3()" class="fa fa-calendar" aria-hidden="true"></i>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3 offset-top-20">
                  <div class="input-group input-with-date">
                    <label>Data Final</label>
                    <datepicker ref="programaticOpen4" v-model="filters.finalDate" :language="ptBR"
                                :format="customFormatter"/>
                    <i v-on:click="openCalendar4()" class="fa fa-calendar" aria-hidden="true"></i>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3 offset-top-20">
                  <div class="form-group">
                    <label for="id">ID da empresa</label>
                    <input v-model="filters.id" type="text" class="form-control" id="id" name="id"/>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3 offset-top-20">
                  <div class="form-group">
                    <label for="featureType">Feature</label>
                    <select v-model="filters.featureType" id="featureType" name="featureType" required>
                      <option value="">Selecione</option>
                      <option v-for="(s, index) in listFilter" v-bind:value="s.featureType">
                        {{ s.name }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3 offset-top-20">
                  <button v-on:click="getList()">
                    Pesquisar
                  </button>
                </div>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loadingList && dataResult.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box orderBy">
                <div class="portlet-title">
                  <div class="caption">
                    <span class="caption-subject font-blue bold uppercase">
                      Quantidade total ({{ dataResult.length }})
                    </span>
                  </div>

                  <a v-on:click="downloadActualListExcel()" class="btn-all-excel right" title="Imprimir">
                    <span>Gerar Excel</span>
                    <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                  </a>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th>EMPRESA</th>
                        <th>VALOR</th>
                        <th>TIPO</th>
                        <th>HISTÓRICO DE ATUALIZAÇÃO</th>
                        <th>DATA</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(c, index) in dataResult">
                        <td>
                          <a v-bind:href="
                                '/detalhes-da-empresa/' +
                                c.companyId +
                                '/' +
                                c.contextCode
                              " target="_blank" class="link">{{ c.name }}</a>
                        </td>
                        <td>R$ {{ c.price }}</td>
                        <td>{{ c.featureTypeStr }}</td>
                        <td>{{ c.logSubscriptionHistoryUpdateTypeStr }}</td>
                        <td>{{ c.createdAt | formatFullDate }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../../components/default/topMenu.vue";
import pageHeader from "../../../components/default/pageHeader.vue";
import fullLoading from "../../../components/default/fullLoading.vue";
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import datepicker from "vuejs-datepicker";
import swal from "sweetalert";

import {
  GET_LIST_UPSELL,
  CHANGE_DADE_FEATURE
} from "../../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../../requestConfig";
import {
  UTIL
} from "../../../../../utils";
import moment from "moment";
import {
  ALERT_SERVICE
} from "../../../../../msgAlertService";

export default {
  name: "list-upsell",
  components: {
    topMenu,
    pageHeader,
    datepicker,
    fullLoading,
  },
  data() {
    return {
      ptBR: ptBR,
      filters: {
        featureType: "",
        initialDate: "",
        finalDate: "",
        id: "",
      },
      failRequest: false,
      loadingList: false,
      loading: false,
      pageNumber: 1,
      qtdTotal: 0,
      pageQtd: 20,
      totalPages: 0,
      dataResult: {},
      listFilter: []
    };
  },
  methods: {
    openCalendar3: function () {
      this.$refs.programaticOpen3.showCalendar();
    },
    openCalendar4: function () {
      this.$refs.programaticOpen4.showCalendar();
    },
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    getList() {
      this.dataResult = [];

      this.loadingList = true;
      this.failRequest = false;

      let url = GET_LIST_UPSELL;
      url += "?p=1";
      url += "&r=500";

      if (this.filters.id) {
        url += "&id=" + this.filters.id;
      }

      if (this.filters.featureType) {
        url += "&feature=" + this.filters.featureType;
      }

      if (this.filters.initialDate) {
        url +=
          "&initDate=" + moment(this.filters.initialDate).format("YYYY-MM-DD");
      }

      if (this.filters.finalDate) {
        url +=
          "&endDate=" + moment(this.filters.finalDate).format("YYYY-MM-DD");
      }

      UTIL_SERVICE.console("URL SEARCH:", url);
      REQUEST_SERVICE.get(url)
        .then((response) => {
          UTIL_SERVICE.console("RESULT GET_LIST_UPSELL:", response.data);

          this.dataResult = response.data;

          this.loadingList = false;
        })
        .catch((reason) => {
          this.loadingList = false;
          this.failRequest = true;

          ALERT_SERVICE.showMsgError(reason.response.data.erros);
        });
    },
    downloadActualListExcel() {
      let bodyValue = [];
      this.dataResult.map((value, index) => {
        bodyValue.push([
          value.name,
          value.price,
          value.featureTypeStr,
          value.logSubscriptionHistoryUpdateTypeStr,
          moment(String(value.createdAt)).format("DD/MM/YYYY hh:mm"),
        ]);

        if (index + 1 === this.dataResult.length) {
          let headValue = [
            "EMPRESA",
            "VALOR",
            "TIPO",
            "HISTÓRICO DE ATUALIZAÇÃO",
            "DATA",
          ];
          window.downloadListExcel(headValue, bodyValue, "Relatório de Upsell");
        }
      });
    },
    getDadeFeature() {
      this.loadingList = true;
      this.failRequest = false;

      let url = CHANGE_DADE_FEATURE + this.filters.featureType;
      UTIL_SERVICE.console("URL SEARCH:", url);
      REQUEST_SERVICE.requestContext('GET', url, this.filters.featureType).then((response) => {
        UTIL_SERVICE.console("RESULT CHANGE_DADE_FEATURE:", response.data);

        this.listFilter = response.data;

        this.loadingList = false;
      })
        .catch((reason) => {
          this.loadinDadeList = false;
          this.failRequest = true;
        });
    },
  },
  beforeMount() {
    this.getDadeFeature();
  },
};
</script>

<style lang="scss">
.btn-all-excel {
  cursor: pointer;
  margin-left: 5px;
  display: inline-block;
  padding: 8px 10px;
  background-color: #00a651;
  color: #fff;
  margin-bottom: 20px;
  border-radius: 4px !important;
  float: right;
  font-weight: 600;
  margin-top: 0;
  border: none;

  i {
    margin-left: 5px;
  }

  &:hover {
    color: #fff;
    background-color: #008d45;
  }
}

.complete-filter {
  .input-with-date {
    width: 100%;

    input {
      width: 100%;
    }
  }

  button {
    width: auto;
    margin-left: 4px;
    padding: 0 20px;
  }
}

.price-value {
  display: block;
  margin-bottom: 20px;
  font-weight: 600;
  text-transform: capitalize;
  color: #444d58;
  font-size: 16px;
  margin-left: 6px;
  margin-top: 0;

  span {
    color: #e7505a;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/payment/list-upsell/listUpSell.vue